export default "__VITE_ASSET__UgIDl0CT__"